import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

let groupId = 0

export default class extends Controller {
  static targets = ['position']
  static values = { group: String, handle: String }

  connect () {
    this.element.sortableController = this

    this.sortable = Sortable.create(this.element, {
      // Lists sharing a group value can drag items between each other
      group: this.groupValue || `sortable-${groupId++}`,
      animation: 150,
      onEnd: this.end.bind(this),
      onAdd: this.added.bind(this),
      filter: 'input, button, select, textarea',
      preventOnFilter: false,
      // Carries an empty custom type instead of the item's text, which text
      // editors dragged across would accept as a drop. Firefox needs some data
      // on the drag to start it.
      setData: dataTransfer => dataTransfer.setData('application/x-sortable-item', ''),
      ...(this.hasHandleValue && { handle: this.handleValue })
    })
  }

  disconnect () {
    this.sortable.destroy()
  }

  update () {
    this.positionTargets.forEach((position, index) => (position.value = index))
  }

  end () {
    this.update()
  }

  added (event) {
    this.update()
    this.dispatch('added', { detail: { item: event.item } })
  }
}
